import { api } from '../baseConfig';

export interface IApiVersion {
    'api-version': string;
    version: string;
}

export interface IImmoConfig {
    helpUrl?: string | null;
}

export const apiVersion = api.injectEndpoints({
    endpoints: (builder) => ({
        getApiVersion: builder.query<IApiVersion, void>({
            query: () => ({
                url: '/immo/v1/versionInfo',
                method: 'GET',
            }),
        }),
        getImmoConfig: builder.query<IImmoConfig, void>({
            query: () => ({
                url: '/immo/v1/config',
                method: 'GET',
            }),
        }),
    }),
});

export const { useGetApiVersionQuery, useGetImmoConfigQuery } = apiVersion;
